import { Empty, message, Select, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useState } from "react";

export const RecruiterSelector = ({
  fetchRecruiters: fetchRecruitersApi,
  clientId,
  value,
  onChange,
  disabled,
  style,
  className,
  placeholder = "Select Recruiter",
  allowClear = true,
  showSearch = true,
  ...props
}) => {
  const [options, setOptions] = useState({ clientId: null, data: [] });
  const [loading, setLoading] = useState(false);

  const handleDropdownVisibleChange = async (open) => {
    if (!open || !fetchRecruitersApi || !clientId) return;

    if (options.clientId !== clientId || !options.data.length) {
      try {
        setLoading(true);
        setOptions({ clientId: null, data: [] });

        const res = await fetchRecruitersApi(clientId);
        const recruiterOptions = (res.data || res || []).map((recruiter) => ({
          value: recruiter.id,
          label: recruiter.name,
        }));

        setOptions({ clientId, data: recruiterOptions });
      } catch (error) {
        const status = error?.response?.status;
        const errorMessage = error?.response?.data?.message || error?.message;

        if (status === 404) {
          message.error("Client not found");
        } else {
          message.error(
            errorMessage || "Failed to fetch recruiters. Please try again.",
          );
        }

        setOptions({ clientId, data: [] });
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChange = (selectedValue) => {
    if (!onChange) return;

    if (!selectedValue) {
      onChange(null);
      return;
    }

    onChange(selectedValue);
  };

  return (
    <Select
      placeholder={placeholder}
      options={options.data}
      value={value}
      onChange={handleChange}
      disabled={disabled || !fetchRecruitersApi}
      loading={loading}
      allowClear={allowClear}
      showSearch={showSearch}
      labelInValue
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      className={className}
      style={style || { width: "100%" }}
      onDropdownVisibleChange={handleDropdownVisibleChange}
      notFoundContent={
        loading ? (
          <Spin indicator={<LoadingOutlined spin />} />
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )
      }
      {...props}
    />
  );
};
